import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as siteActions from '../../actions/siteActions';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import systemsToSelectOptions from '../../utils/systemSelectFormatter';
import SiteForm from './SiteForm';
import { Row, Col } from 'reactstrap';

class ManageSitePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      site: Object.assign({}, props.site),
      selectedActiveOption: props.site ? props.site.active : null,
      selectedMasterOption: props.site ? props.site.hasMaster : null,
      selectedSystem: props.site ? props.site.systemId : null,
      errors: {},
      saving: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.site) {
      if (this.props.site.id !== nextProps.site.id) {
        this.setState({ site: Object.assign({}, nextProps.site) });
      }
    }
  }

  redirectSuccess = (msg) => {
    this.setState({ saving: false });
    toast.success(msg);
    this.props.history.push('/sites');
  };

  formIsValid() {
    const { site } = this.state;
    let errors = {};
    let isValid = true;

    if (site.siteId.length < 3) {
      errors.siteId = 'Site ID must be at least 3 characters.';
      isValid = false;
    }
    if (site.systemId === null) {
      errors.systemId = 'Select a system.';
      isValid = false;
    } else if (site.systemId === '') {
      errors.systemId = 'Select a system.';
      isValid = false;
    }
    if (site.siteName.length < 3) {
      errors.siteName = 'Site name must be at least 3 characters.';
      isValid = false;
    }
    if (site.city.length < 3) {
      errors.city = 'City must be at least 3 characters.';
      isValid = false;
    }
    if (site.county.length < 3) {
      errors.county = 'County must be at least 3 characters.';
      isValid = false;
    }
    if (site.hasMaster === null) {
      errors.hasMaster = 'Select an option.';
      isValid = false;
    } else if (site.hasMaster === '') {
      errors.hasMaster = 'Select an option.';
      isValid = false;
    }
    if (site.masterMultiplier.length < 1) {
      errors.masterMultiplier = 'Enter the master meter multiplier.';
      isValid = false;
    }
    if (site.isActive === null) {
      errors.isActive = 'Select an option';
      isValid = false;
    } else if (site.isActive === '') {
      errors.isActive = 'Select an option';
      isValid = false;
    }

    this.setState({ errors: errors });
    return isValid;
  }

  saveSite = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    this.setState({ saving: true });
    const site = Object.assign({}, this.state.site);
    if (site.facilityDescription === '' || site.facilityDescription === 'N/A')
      site.facilityDescription = null;
    this.props.actions
      .saveSite(this.state.site)
      .then(() => this.redirectSuccess('Site saved'))
      .catch((error) => {
        toast.error(error.message);
        this.setState({ saving: false });
      });
  };

  deleteSite = (event) => {
    event.preventDefault();
    this.setState({ saving: true });
    this.props.actions
      .deleteSite(this.state.site)
      .then(() => this.redirectSuccess('Site marked as inactive.'))
      .catch((error) => {
        toast.error(error.message);
        this.setState({ saving: false });
      });
  };

  updateSiteState = (event) => {
    const field = event.target.id;
    let site = Object.assign({}, this.state.site);
    site[field] = event.target.value;
    this.setState({ site: site });
  };

  updateHasMaster = (selectedOption) => {
    let siteToUpdate = Object.assign({}, this.state.site);
    siteToUpdate.hasMaster = selectedOption.value;
    return this.setState({
      site: siteToUpdate,
      selectedMasterOption: selectedOption.value,
    });
  };

  updateActive = (selectedOption) => {
    let siteToUpdate = Object.assign({}, this.state.site);
    siteToUpdate.isActive = selectedOption.value;
    return this.setState({
      site: siteToUpdate,
      selectedActiveOption: selectedOption.value,
    });
  };

  updateSelectedSystem = (selectedOption) => {
    let siteToUpdate = Object.assign({}, this.state.site);
    siteToUpdate.systemId = selectedOption.value;
    return this.setState({
      site: siteToUpdate,
      selectedSystem: selectedOption.value,
    });
  };

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <h1 className="text-center my-4">Manage Site</h1>
          </Col>
        </Row>
        <SiteForm
          site={this.state.site}
          saving={this.state.saving}
          onChange={this.updateSiteState}
          onSave={this.saveSite}
          onDelete={this.deleteSite}
          systems={this.props.systems}
          selectedActiveOption={this.state.selectedActiveOption}
          onActiveChange={this.updateActive}
          onMasterChange={this.updateHasMaster}
          selectedMasterOption={this.state.selectedMasterOption}
          selectedSystem={this.state.selectedSystem}
          onSystemChange={this.updateSelectedSystem}
          errors={this.state.errors}
        />
      </div>
    );
  }
}

ManageSitePage.propTypes = {
  site: PropTypes.object,
};

function getSiteById(sites, id) {
  const site = sites.filter((site) => site.id === id);
  if (site) return site[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const siteId = Number.parseInt(id, 10);

  let currentSite = {
    id: '',
    siteId: '',
    systemId: '',
    siteName: '',
    city: '',
    county: '',
    hasMaster: '',
    masterMultiplier: '',
    isActive: '',
  };

  if (siteId && state.sites.length > 0) {
    currentSite = getSiteById(state.sites, siteId);
  }

  return {
    site: currentSite,
    systems: systemsToSelectOptions(state.systems),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(siteActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageSitePage)
);



// WEBPACK FOOTER //
// ./src/components/site/ManageSitePage.js